import { Component } from '@angular/core';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Router ,ActivatedRoute} from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { DatePipe, Location } from '@angular/common';

@Component({
  selector: 'app-payment-deposits',
  templateUrl: './payment-deposits.component.html',
  styleUrls: ['./payment-deposits.component.css']
})
export class PaymentDepositsComponent {
  DepositRegFg!:FormGroup;
  currentStep: string = 'Deposit';
  id:any="0"
  totalBalance:any
  constructor(private data:DataService,private PaymentConfigService:PaymentConfigService , private toastMsgService : ToastmsgService,private fb : FormBuilder,
    private route :ActivatedRoute,){
      this.data.portMessage.subscribe((message:any) => this.id = message)
      console.log(this.id);
      this.dataFields()
      this.GetBalance()
      this.getHistoryBalance()
    }
   
dataFields(){
  this.DepositRegFg=this.fb.group({
    "userUid": [this.id,[Validators.required]],
    "entryType": ['credit',[Validators.required]],
    "category": ['DEPOSIT',[Validators.required]],
    "amount": ['',[Validators.required]],
    "comment": [],
    
  });
}

changeStep(step: string) {
  this.currentStep = step;

  if(this.currentStep==="Deposit"){
    this.DepositRegFg=this.fb.group({
      "userUid": [this.id,[Validators.required]],
      "entryType": ['credit',[Validators.required]],
      "category": ['DEPOSIT',[Validators.required]],
      "amount": ['',[Validators.required]],
      "comment": [],
      
    });
  }else if(this.currentStep==="Credit"){
    this.DepositRegFg=this.fb.group({
      "userUid": [this.id,[Validators.required]],
      "entryType": ['credit',[Validators.required]],
      "category": ['CREDIT',[Validators.required]],
      "amount": ['',[Validators.required]],
      "comment": [],
      
    });
  }
  this.getHistoryBalance()
}

  savePaymentDeposits(){
    
 
    this.PaymentConfigService.savePaymentDeposits(this.DepositRegFg.value)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "User Balance Saved Successfully!",msgTitle : "Success", msgType : "I"});
        this.GetBalance();
        if(this.currentStep==="Deposit"){
          this.DepositRegFg=this.fb.group({
            "userUid": [this.id,[Validators.required]],
            "entryType": ['credit',[Validators.required]],
            "category": ['DEPOSIT',[Validators.required]],
            "amount": ['',[Validators.required]],
            "comment": [],
            
          });
        }else if(this.currentStep==="Credit"){
          this.DepositRegFg=this.fb.group({
            "userUid": [this.id,[Validators.required]],
            "entryType": ['credit',[Validators.required]],
            "category": ['CREDIT',[Validators.required]],
            "amount": ['',[Validators.required]],
            "comment": [],
            
          });
        }        } else {
          const body : any = res.body;
          this.registerDepositErrorMsg(res.status,body?.result);
        } 
  
      },error : (err) => {
  
        this.registerDepositErrorMsg(err.status,err.error);
      }
    }
  )
  }
  
  registerDepositErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to save User Balance",msgTitle : "Warning", msgType : "W"});
  } else {
  
    this.toastMsgService.setMsg({msg : "Failed to save User Balance",msgTitle:  "Warning", msgType : "W"});
  } 
}

GetBalance(){

        this.PaymentConfigService
        .getBalance(this.id)
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data=res
           this.totalBalance=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
      onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }


BalanceHistoryList:any=[]
getHistoryBalance(){
  let medium:any='DEPOSIT'
if(this.currentStep==='Deposit'){
  medium='DEPOSIT'
}else if(this.currentStep==='Credit'){
  medium='CREDIT'

}
        this.PaymentConfigService
        .getHistoryBalance(medium,this.id)
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data=res
           this.BalanceHistoryList=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }

      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy HH:mm:ss");
        // convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    
        }
        return convertedValue;
      }
}